export const config = {
  api_url: process.env.VUE_APP_API_URL,
  token_key: "user-auth",
};
